var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({class:['ql-button', {'primary': _vm.type === 'primary'}],style:({width: _vm.buttonWidth}),on:{"click":function($event){return _vm.$emit('click')}}},'button',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }